var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlakiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 1.063A.57.57 0 0 0 .812.5a.555.555 0 0 0-.562.563V11.938c0 .328.234.562.563.562a.555.555 0 0 0 .562-.563V9.595l1.875-.469a4.17 4.17 0 0 1 2.86.328c1.054.516 2.25.586 3.327.164l.82-.305c.282-.117.493-.374.493-.703V2.07c0-.539-.586-.89-1.055-.656l-.234.117a3.872 3.872 0 0 1-3.445 0 3.84 3.84 0 0 0-2.649-.304l-1.992.492v-.657zm0 1.828 2.25-.563a2.67 2.67 0 0 1 1.898.211c1.266.633 2.766.68 4.102.14v5.673l-.586.21a2.986 2.986 0 0 1-2.414-.117 5.333 5.333 0 0 0-3.656-.398l-1.594.398V2.891z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlakiness);
export default __webpack_public_path__ + "static/media/flakiness.9f817213bae88cda1c6d122642bf405c.svg";
export { ForwardRef as ReactComponent };